import React, { Fragment } from 'react';
import { Logo } from '../../layout/Logo';
import { ArrowCounterClockwise, X } from '@phosphor-icons/react';
type Stage = 'anunt' | 'profil' | 'cont';
interface OnboardingHeaderProps {
  stage: Stage;
  onReset: () => void;
  onClose: () => void;
  onJumpToStage?: (stage: Stage) => void;
  listingOnly?: boolean;
}
const STAGE_ORDER: Stage[] = ['anunt', 'profil', 'cont'];
const STAGE_LABEL: Record<Stage, string> = {
  anunt: 'Anunț',
  profil: 'Profil',
  cont: 'Cont'
};
function IconButton({
  onClick,
  label,
  children
}: {
  onClick: () => void;
  label: string;
  children: React.ReactNode;
}) {
  return <div className="relative group" data-id="element-1485">
      <button onClick={onClick} aria-label={label} className="p-2 rounded-md text-light-3 hover:text-light-1 hover:bg-dark-2 transition-colors" data-id="element-1486">
        {children}
      </button>
      <span role="tooltip" className="pointer-events-none absolute top-full right-0 mt-1.5 whitespace-nowrap px-2 py-1 rounded-md text-xs font-medium bg-dark-3 text-light-1 border border-dark-4 opacity-0 group-hover:opacity-100 transition-opacity z-50 shadow-lg" data-id="element-1487">
        {label}
      </span>
    </div>;
}
export function OnboardingHeader({
  stage,
  onReset,
  onClose,
  onJumpToStage,
  listingOnly = false
}: OnboardingHeaderProps) {
  const currentIdx = STAGE_ORDER.indexOf(stage);
  return <header className="sticky top-0 z-50 w-full bg-dark-1 border-b border-dark-3" data-id="element-1488">
      <div className="max-w-3xl mx-auto px-4 h-16 flex items-center justify-between gap-3" data-id="element-1489">
        {/* Logo — hidden on mobile to give the breadcrumb room */}
        <div className="hidden sm:block flex-shrink-0" data-id="element-1490">
          <Logo className="h-6 w-auto" onClick={onClose} data-id="element-1491" />
        </div>

        {listingOnly ? <span className="text-sm font-medium text-light-1 flex-1 sm:flex-initial" data-id="element-1492">
            Creează-ți anunțul
          </span> : <nav aria-label="Etape onboarding" className="flex items-center gap-2 text-sm font-medium flex-1 sm:flex-initial min-w-0" data-id="element-1493">
            {STAGE_ORDER.map((s, i) => {
          const isCurrent = s === stage;
          const isPast = i < currentIdx;
          const canJump = isPast && !!onJumpToStage;
          return <Fragment key={s} data-id="element-1494">
                  {canJump ? <button type="button" onClick={() => onJumpToStage!(s)} className="text-light-3 hover:text-light-1 hover:underline underline-offset-4 transition-colors cursor-pointer" data-id="element-1495">
                      {STAGE_LABEL[s]}
                    </button> : <span className={isCurrent ? 'text-light-1 font-semibold' : 'text-light-3'} aria-current={isCurrent ? 'step' : undefined} data-id="element-1496">
                      {STAGE_LABEL[s]}
                    </span>}
                  {i < STAGE_ORDER.length - 1 && <span className="text-dark-4" aria-hidden="true" data-id="element-1497">
                      ·
                    </span>}
                </Fragment>;
        })}
          </nav>}

        <div className="flex items-center gap-1 flex-shrink-0" data-id="element-1498">
          <IconButton onClick={onReset} label="Începe de la zero" data-id="element-1499">
            <ArrowCounterClockwise className="w-5 h-5" weight="bold" data-id="element-1500" />
          </IconButton>
          <IconButton onClick={onClose} label="Închide onboarding" data-id="element-1501">
            <X className="w-5 h-5" weight="bold" data-id="element-1502" />
          </IconButton>
        </div>
      </div>
    </header>;
}